import { Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Layout from './components/Layout';
import PreviewLayout from './components/PreviewLayout';
import HomePreview from './pages/HomePreview';
import PreviewPhotosPage from './pages/preview/PreviewPhotosPage';
import Menu from './pages/Menu';
import Collection from './pages/Collection';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import CakeRequest from './pages/CakeRequest';
import CakeRequestPrint from './pages/cakeRequest/CakeRequestPrint';
import Order from './pages/Order';
import Gallery from './pages/Gallery';
import Guides from './pages/Guides';
import GuideArticle from './pages/GuideArticle';
import EventCategoryLandingPage from './pages/EventCategoryLandingPage';
import EventsPage from './pages/Events';
import CampaignLayout from './components/CampaignLayout';
import CampaignPage from './pages/CampaignPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PickupAndReturns from './pages/PickupAndReturns';
import BakeryInBarrie from './pages/BakeryInBarrie';

// Admin imports
import {
  AdminLayout,
  ProtectedRoute,
  Login as AdminLogin,
  Dashboard as AdminDashboard,
  MenuList as AdminMenuList,
  MenuForm as AdminMenuForm,
  Promos as AdminPromos,
  Redemptions as AdminRedemptions,
  Orders as AdminOrders,
  Customers as AdminCustomers,
  Messages as AdminMessages,
  Gallery as AdminGallery,
  Images as AdminImages,
  Settings as AdminSettings,
  Integrations as AdminIntegrations,
  Help as AdminHelp,
  ProductOptions as AdminProductOptions,
  Articles as AdminArticles,
  ArticleForm as AdminArticleForm,
  Collections as AdminCollections,
  EventCategories as AdminEventCategories,
  EventCategoryEditor as AdminEventCategoryEditor,
  Events as AdminEvents,
  Seasons as AdminSeasons,
  Holidays as AdminHolidays,
  HomepageEditor as AdminHomepageEditor,
  TaxReports as AdminTaxReports,
  MenuCategories as AdminMenuCategories,
  Campaigns as AdminCampaigns,
  EmailSignups as AdminEmailSignups,
  Media as AdminMedia,
} from './admin';

function App() {
  return (
    <CartProvider>
      <Routes>
        {/* ========================================
            PUBLIC WEBSITE ROUTES
            Wrapped in Layout with Header/Footer
        ======================================== */}
        <Route path="/" element={<Layout><HomePreview /></Layout>} />
        {/* Old /preview URL. The facelift is now the live homepage. */}
        <Route path="/preview" element={<Navigate to="/" replace />} />
        {/* Tammy's phone shot list. Still private. Not in the live header or sitemap. */}
        <Route path="/preview/photos" element={<PreviewLayout><PreviewPhotosPage /></PreviewLayout>} />
        <Route path="/menu" element={<Layout><Menu /></Layout>} />
        <Route path="/menu/:slug" element={<Layout><Collection /></Layout>} />
        {/* Product detail page — reached by clicking any product card on the Home page */}
        <Route path="/product/:id" element={<Layout><ProductDetail /></Layout>} />
        <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
        <Route path="/order" element={<Layout><Order /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/bakery-in-barrie" element={<Layout><BakeryInBarrie /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/cake-request" element={<Layout><CakeRequest /></Layout>} />
        <Route path="/cake-request/print" element={<CakeRequestPrint />} />
        <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="/pickup-and-returns" element={<Layout><PickupAndReturns /></Layout>} />
        <Route path="/guides" element={<Layout><Guides /></Layout>} />
        <Route path="/guides/:slug" element={<Layout><GuideArticle /></Layout>} />
        {/* Upcoming events & classes listing page */}
        <Route path="/events" element={<Layout><EventsPage /></Layout>} />
        <Route path="/events/:slug" element={<Layout><EventCategoryLandingPage /></Layout>} />
        <Route path="/campaign/:slug" element={<CampaignLayout><CampaignPage /></CampaignLayout>} />

        {/* ========================================
            ADMIN ROUTES - "Tammy's Self Service"
            Separate layout, no public header/footer
            Protected routes require authentication
        ======================================== */}
        
        {/* Admin login - no layout wrapper, no protection */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Admin pages - wrapped in ProtectedRoute + AdminLayout */}
        <Route path="/admin" element={<ProtectedRoute><AdminLayout><AdminDashboard /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/menu" element={<ProtectedRoute><AdminLayout><AdminMenuList /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/menu/new" element={<ProtectedRoute><AdminLayout><AdminMenuForm /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/menu/:itemId" element={<ProtectedRoute><AdminLayout><AdminMenuForm /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/categories" element={<ProtectedRoute><AdminLayout><AdminMenuCategories /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/holidays" element={<ProtectedRoute><AdminLayout><AdminHolidays /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/collections" element={<ProtectedRoute><AdminLayout><AdminCollections /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/product-options" element={<ProtectedRoute><AdminLayout><AdminProductOptions /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/articles" element={<ProtectedRoute><AdminLayout><AdminArticles /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/articles/new" element={<ProtectedRoute><AdminLayout><AdminArticleForm /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/articles/:id" element={<ProtectedRoute><AdminLayout><AdminArticleForm /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/event-categories" element={<ProtectedRoute><AdminLayout><AdminEventCategories /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/event-categories/:id/editor" element={<ProtectedRoute><AdminLayout><AdminEventCategoryEditor /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/homepage-features" element={<ProtectedRoute><AdminLayout><AdminHomepageEditor /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/homepage-editor" element={<ProtectedRoute><AdminLayout><AdminHomepageEditor /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/promos" element={<ProtectedRoute><AdminLayout><AdminPromos /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/redemptions" element={<ProtectedRoute><AdminLayout><AdminRedemptions /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/orders" element={<ProtectedRoute><AdminLayout><AdminOrders /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/customers" element={<ProtectedRoute><AdminLayout><AdminCustomers /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/messages" element={<ProtectedRoute><AdminLayout><AdminMessages /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/gallery" element={<ProtectedRoute><AdminLayout><AdminGallery /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/images" element={<ProtectedRoute><AdminLayout><AdminImages /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute><AdminLayout><AdminSettings /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/tax-reports" element={<ProtectedRoute><AdminLayout><AdminTaxReports /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/integrations" element={<ProtectedRoute><AdminLayout><AdminIntegrations /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/help" element={<ProtectedRoute><AdminLayout><AdminHelp /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/campaigns" element={<ProtectedRoute><AdminLayout><AdminCampaigns /></AdminLayout></ProtectedRoute>} />
        {/* Events & Classes — Tammy manages individual events (dates, times, spots, prices) */}
        <Route path="/admin/events" element={<ProtectedRoute><AdminLayout><AdminEvents /></AdminLayout></ProtectedRoute>} />
        {/* Seasonal Content — tag items to seasons; Phase 2 will auto-activate them on the right dates */}
        <Route path="/admin/seasons" element={<ProtectedRoute><AdminLayout><AdminSeasons /></AdminLayout></ProtectedRoute>} />
        {/* Email List — newsletter signups from the homepage widget */}
        <Route path="/admin/email-signups" element={<ProtectedRoute><AdminLayout><AdminEmailSignups /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/media" element={<ProtectedRoute><AdminLayout><AdminMedia /></AdminLayout></ProtectedRoute>} />
      </Routes>
    </CartProvider>
  );
}

export default App;
